import { get, post, put, deleteReq } from '@/utils/http'

// // 账号密码登陆
// export const accountlogin = (data = {}, config = {}) => {
//   data = {
//     grantType: 'password',
//     scope: 'server',
//     // client_id: 'client_2',
//     // client_secret: 'abcd',
//     client_id: process.env.REACT_APP_CLIENT_ID,
//     client_secret: process.env.REACT_APP_CLIENT_SECRET,
//     ...data,
//   }
//   return get('/passport/oauth/token', data, config)
// }

// 首次登陆修改默认密码
export const changePassword = (data = {}) => post('/passport/oauth/changePassword', data)

// 获取扫码登陆信息
export const sweepCodeInfo = () => get('/passport/oauth/scan-code-login-information');

// 企业微信扫码登陆
export const sweepCodeLogin = (data = {}) => get('/passport/weChatWorkLogin', data);

// 忘记密码
export const forgetPassword = (data = {}) => post('/passport/oauth/resetPassword', data);

// 验证token有效性（token 通过 Authorization 请求头传递，不再拼接在 URL 上）
export const checkToken = (access_token) =>
  get('/passport/checkToken', {}, { headers: { Authorization: `bearer ${access_token}` } })

// 获取用户头像等信息
export const currentUserBrief = (data = {}) => get(`/passport/current-user-brief`, data)

// 检查是否需要修改邮箱
export const isNeedModifyEmail = () => get('/passport/profile/need-modify-email');

// 检查是否需要修改密码
export const isNeedModifyPass = () => get('/passport/user/check-account-security');

// 给邮箱发送验证码
export const sendCodeToEmail = (data = {}) => get('/passport/profile/send-email-verification-code', data);

// 绑定邮箱
export const bingdingEmail = (data) => put('/passport/profile/email', data);

// 退出登陆（token 由请求拦截器统一以 Authorization 头携带，不再拼接在 URL 上）
export const userLogout = () => deleteReq('/passport/logout')

// 发送验证码
export const sendVerificationCode = (data = {}) => post('/passport/send-verification-code', data);

// 重置密码
export const resetPassword = (data = {}) => post('/passport/oauth/reset-password', data);

// 获取公钥
export const getPublicKey = () => get('/passport/getPublicKey')

// 获取手机号防水码
export const graphicVerificationCode = (data = {}) => get('/passport/graphic-verification-code', data);

// 获取手机号验证码
export const sendMobileCode = (data = {}) => post('/passport/sendMobileCode', data);

// 获得密码临近过期提示
export const passwordExpire = (userId = '') => get(`/passport/user/${userId}/password-expire`);
